<template>
    <div class="container">
        <div class="icon-wrap">
            <van-icon name="passed" color="#FFF" size="64"/>
            <div class="label">支付完成</div>
<!--            <div class="des">请回到微信查看内容</div>-->
        </div>
        <van-button style="margin:30px 5%;width:90%"  type="default" block url="djweball://">返回查看内容</van-button>
    </div>
</template>
<script>
    export default {
        name: 'PaySucceed',
        data() {
            return {}
        },
        created: function () {
        },
        methods: {
            go_weixin(){
                location.href = 'weixin://';
            }
        }
    }
</script>
<style scoped lang="less">
    .container {
        width: 100%;
        .icon-wrap {
            padding: 30px 0;
            width: 100%;
            background-color: #1FC164;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .label{
            color: #FFF;
            font-size:18px;
            margin: 15px;
        }
        .des{
            color: #FFF;
            font-size:16px;
        }
    }
</style>
